import { Grid } from "@mui/material";
import { MainTitle, MaxWidth } from "../../styles/theme";
import VehicleHistoryTable from "../../components/Vehicle/VehicleHistoryTable";

function VehicleHistory() {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <MaxWidth>
          <MainTitle>차량 운행 내역</MainTitle>
          <VehicleHistoryTable />
        </MaxWidth>
      </Grid>
    </Grid>
  );
}

export default VehicleHistory;
